import {
  KalturaPersonalList,
  KalturaPersonalListListResponse,
  PersonalListAddAction,
} from '@kaltura-ott/ott-client-types/api/types';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AdditionalSearchKey, SearchKeys } from '../interfaces';

import { addKsql } from './category.tree.helper';
import { MediaType } from './dms';
import { kalturaClient } from './kaltura-clent';

interface AggregatedKsqlArgs {
  searchString?: string;
  searchAttributes: SearchKeys[] | SearchKeys;
  kSql: string;
  providerKsql: string;
}

interface AggregatedKsqlForPersonsArgs {
  searchString?: string;
  assetTypes: { [type in MediaType]: string };
  kSql: string;
}

const getEscapedString = (searchString?: string): string =>
  searchString?.replace(/'/g, '%27').replace(/"/g, '%22') || '';

/**
 * Get kSql for search
 *
 * @returns: kSql string
 */

export const getAggregatedKsql = ({
  searchString,
  searchAttributes,
  kSql,
  providerKsql,
}: AggregatedKsqlArgs): string => {
  const escapedString = getEscapedString(searchString);
  const searchAttributesArray: SearchKeys[] = Array.isArray(searchAttributes) ? searchAttributes : [searchAttributes];

  const substring = searchAttributesArray
    .map((attr) => {
      if (attr === 'original_name') {
        return `${SearchKeys[attr]}^'${escapedString}' ${AdditionalSearchKey[attr]}^'${escapedString}' `;
      } else {
        return `${SearchKeys[attr]}^'${escapedString}' `;
      }
    })
    .join(' ');

  return `(and (and (or ${substring}) ${kSql}) ${providerKsql})`;
};

export const getAggregatedKsqlForPersons = ({
  searchString,
  assetTypes,
  kSql,
}: AggregatedKsqlForPersonsArgs): string => {
  const escapedString = getEscapedString(searchString);
  const searchKsql = `(and name^'${escapedString}' asset_type='${assetTypes[MediaType.Person]}')`;
  return addKsql(searchKsql, kSql);
};

interface AddToPersonalListArgs {
  assetType: number;
  assetId: number;
  partnerListType: number;
}

/**
 * Adds to chosen_search_list
 */

export const addToPersonalList = ({
  assetType,
  assetId,
  partnerListType,
}: AddToPersonalListArgs): Observable<KalturaPersonalListListResponse> => {
  const name = `Chosen_Search_Item_${Number(assetId)}`;
  const ksql = assetType === 0 ? `epg_id='${Number(assetId)}'` : `media_id='${Number(assetId)}'`;

  const action = new PersonalListAddAction({
    personalList: new KalturaPersonalList({ partnerListType: partnerListType, name, ksql }),
  });
  const client = kalturaClient();
  return client.request(action).pipe(
    catchError((error) => {
      return of(error);
    }),
  );
};
